<template lang="html">

  <div class="ui top attached menu" v-bind:id="id" >
    <a class="item" href="/">
      <!-- <img src="/favicon.png" style="width: 28px;"/> -->
      <img v-if="!isDark" v-bin:src="config.logo_light"/>
      <img v-if="isDark"  v-bin:src="config.logo_dark"/>
    </a>

    <span class="schermolargo menu">
      <a class="item" v-for="(tab, index) in config.tabs" v-bind:key="tab.order" v-bind:class="{ 'active': tab.name== activeTab }" v-on:click="tabClick(index)">
        {{ tab.name }}
      </a>
    </span>

    <span class="schermostretto menu">
      <a class="item" v-for="(tab, index) in config.tabs" v-bind:key="tab.order" style="padding-right: 0.65rem; padding-left: 0.65rem;" v-bind:class="{ 'is-active has-text-white': tab.name== activeTab }" v-on:click="tabClick(index)">
        <span class="icon" v-if="tab.icon"><i class="fas" v-bind:class="'fa-'+tab.icon"></i></span>
      </a>
    </span>

    <div class="right menu">
      <a class="item largedevice notification" style="position: static;">
          <notificationManager v-bind:useListener="true"></notificationManager>
      </a>
    </div>

    <bulmaP></bulmaP>
    
  </div>

</template>

<script>
// import notificationManager from '../components/notificationManager.vue'
import bulmaP from '../components/bulma_p.vue'
export default {
  name: 'semanticTabBar',
  components: {
    bulmaP,
  },
  props: {
    id: String,
    data: Object,
  },
  watch: { 
    process: function(newVal) {
      if (!newVal) newVal='/';  else newVal='/'+newVal;
      this.setActiveOnPath(newVal);
    },
  },
  computed: {
    process: function() {
      return this.$store.state.global_state_process;
    },
    config: function() {
      return this.$store.getters.getObject(this.id).data;
    },
    activeTab() {
      var tab = this.config.tabs.find( t => t.path == '/'+this.process )
      return (tab && tab.name) || this.config.active_tab
    },
    editmode: function() {
      return this.$store.getters.getEditMode(this.id);
    },
    romode: function() {
      return this.$store.getters.getROMode(this.id);
    },
    isDark() {
      if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) return true
      return false
    }
  },
  data() {
    return {
      showModal: false,
      isnew: false,
      tabindex: 0,
      tab:{
        name:'',
        path:'',
        index: -1
      },
      burger_open: false,
    }
  },
  mounted: function() {
    let newVal=this.process;
    if (!newVal) newVal='/';  else newVal='/'+newVal;

    console.log('newVal',newVal)
    this.setActiveOnPath(newVal);
    // this.checkNotificationStatus()

  },
  methods: {
    setActiveOnPath: function(newVal) {
      let t=this.config.tabs.find( (t) => { return t.path==(newVal) })
      if (t) this.updateConfig("active_tab", t.name);
      else this.updateConfig("active_tab", '')
    },
  }
}
</script>

<style scoped>
.notification{
  /* padding-left:0%;
  padding-right:0%;
  padding-top: 3%;
  padding-bottom:0%; */
  --bulma-navbar-item-hover-background-l-delta: rgba(0, 128, 0, 0) !important;
  position: static !important;
  margin-bottom: 0;

}


@media screen and (max-width: 1000px) {
.schermostretto { 
 display:block;
}
.schermolargo{ 
 display:none;
}
}

@media screen and (min-width:1001px) {
.schermolargo { 
 display:block;
}
.schermostretto{ 
 display:none;
}
}

</style>
